module.exports = __webpack_public_path__ + "static/img/gongzhu.2691b26f.png";